'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'fan';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f863';
var svgPathData = ['M36.8 259.8c14.9 54.3 63.6 92.4 123.1 92.2c29.6 0 52-3.3 68.9-8.2c10.2-3 21.2-.6 29.4 6.1s12.4 17.2 11.4 27.8l-9.7 97.5c54.3-14.9 92.4-63.6 92.2-123.1c0-29.6-3.3-52-8.2-68.9c-3-10.2-.6-21.2 6.1-29.4s17.2-12.4 27.8-11.4l97.5 9.7c-14.9-54.3-63.6-92.4-123.1-92.2c-29.6 0-52 3.3-68.9 8.2c-10.2 3-21.2 .6-29.4-6.1s-12.4-17.2-11.4-27.8l9.7-97.5c-54.3 14.9-92.4 63.6-92.2 123.1c0 29.6 3.3 52 8.2 68.9c3 10.2 .6 21.2-6.1 29.4s-17.2 12.4-27.8 11.4l-97.5-9.7zM280 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M242.5 134.2c-1.1 10.6 3.2 21 11.4 27.8s19.2 9.1 29.4 6.1c16.9-4.9 39.3-8.2 68.8-8.2l.1 0c59.5-.2 108.2 37.9 123.1 92.2l-97.5-9.7c-10.6-1.1-21 3.2-27.8 11.4s-9.1 19.2-6.1 29.4c4.9 16.9 8.2 39.3 8.2 68.8l0 .1c.2 59.5-37.9 108.2-92.2 123.1l9.7-97.5c1.1-10.6-3.2-21-11.4-27.8s-19.2-9.1-29.4-6.1c-16.9 4.9-39.3 8.2-68.8 8.2l-.1 0c-59.5 .2-108.2-37.9-123.1-92.2l97.5 9.7c10.6 1.1 21-3.2 27.8-11.4s9.1-19.2 6.1-29.4c-4.9-16.9-8.2-39.3-8.2-68.8l0-.1c-.2-59.5 37.9-108.2 92.2-123.1l-9.7 97.5zM480.1 252.7s0 0 0 0c0 0 0 0 0 0zM32 259.3s0 0 0 0c0 0 0 0 0 0s0 0 0 0zM252.7 32s0 0 0 0c0 0 0 0 0 0zm21.6 105.5l3.4-33.9 6.8-68.3c1.9-18.8-13.1-35.5-31.6-31.5C179.9 19.2 127.7 82.7 128 160c0 16.6 1 31.5 2.7 44.9c1.6 12.2 3.9 23.1 6.7 32.8l-33.9-3.4-68.3-6.8C16.4 225.6-.3 240.6 3.7 259.1C19.2 332.2 82.8 384.3 160 384c16.6 0 31.5-1 44.9-2.7c12.2-1.6 23.1-3.9 32.8-6.7l-3.4 33.9-6.8 68.3c-1.9 18.8 13.1 35.5 31.6 31.5C332.2 492.8 384.3 429.3 384 352c0-16.6-1-31.5-2.7-44.9c-1.6-12.2-3.9-23.1-6.7-32.8l33.9 3.4 68.3 6.8c18.8 1.9 35.5-13.1 31.5-31.6C492.8 179.8 429.3 127.7 352 128c-16.6 0-31.5 1-44.9 2.7c-12.2 1.6-23.1 3.9-32.8 6.7zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFan = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;